import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StructureGrayButton } from '../../../../../MyTeamBackofficeStyled';
import { getRootTeamMember } from '../../../../../myTeamBackOffice.actions';
import { useTranslation } from 'react-i18next';
import { useWindowWide } from '../../../../../../../helpers/wideScreen';
import { useAppSelector } from '../../../../../../../app/hooks';
import { StructureType } from '../../../../../myTeamBackOffice.constants';

export const BackOnTopButton = () => {
  const { t } = useTranslation('myTeam');

  const dispatch = useDispatch();
  const { rootTeamMemberTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );
  const { userInfo } = useAppSelector((state) => state.auth);

  const wide = useWindowWide(800);

  if (!rootTeamMemberTrading) return null;

  // eslint-disable-next-line eqeqeq
  const isUpButtonDisabled = rootTeamMemberTrading.id == userInfo.id;

  const goToTop = () => {
    if (!isUpButtonDisabled) {
      dispatch(getRootTeamMember(null, StructureType.TRADING));
    }
  };

  return (
    <StructureGrayButton
      style={{ width: !wide && 50, flex: !wide && 'none' }}
      onClick={goToTop}
      disabled={isUpButtonDisabled}>
      {wide ? t('back_on_top') : t('top')}
    </StructureGrayButton>
  );
};
